import React, { useState } from 'react';
import styled, { StylesProps } from '../../../../../lib/styles';
import carouselBlockSlideStyles from './CarouselBlockSlide_styles';
import CarouselItem, {
  buildBackground,
} from '../../../../../components/presentational/Carousel/CarouselItem';
import clsx from 'clsx';
import { compose } from 'recompose';
import theme, { Brand } from '../../../../../lib/theme';

const {
  layouts,
} = theme;

export interface CarouselSlide {
  image: string;
  mobile_image: string;
  link: string;
}

export interface CarouselBlockSlideProps {
  key: string;
  slide: CarouselSlide;
  brand: Brand;
  makeContentWidth: boolean;
}

const CarouselBlockSlide = ({
  key,
  slide,
  brand,
  makeContentWidth = false,
  styles,
}: CarouselBlockSlideProps & StylesProps<typeof carouselBlockSlideStyles>) => {

  const contentWidthStyles = makeContentWidth ?
    {
      ...layouts.container('l'),
      margin: `0 auto`,
      left: `0`,
      right: `0`,     
    } : {};

  return (
    <CarouselItem key={key} brand={brand} makeContentWidth={makeContentWidth} layout={`content-image-background`}>
      <div
        className={clsx(
          `carousel-slide background-image-slide ${styles.carouselSlide}`
        )}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          whiteSpace: 'normal',
        }}
      >
        <div
          className={`background-image-wrap no-gradient ${
            styles.backgroundImageWrap
          } ${slide.mobile_image ? styles.slideBackground : ''}`}
          style={{
            backgroundImage: buildBackground(slide.image),
            position: 'absolute',
            height: '100%',
            width: '100%',
            backgroundPosition: '50%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            zIndex: -1,
            ...contentWidthStyles,
          }}
        ></div>
        {slide.mobile_image ? (
          <div
            className={`background-image-wrap no-gradient mobile-image-wrap ${styles.slideMobileBackground}`}
            style={{
              backgroundImage: buildBackground(slide.mobile_image),
              position: 'absolute',
              height: '100%',
              width: '100%',
              backgroundPosition: '50%',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              zIndex: -1,
            }}
          ></div>
        ) : (
          <></>
        )}
      </div>
    </CarouselItem>
  );
};
export default compose(styled(carouselBlockSlideStyles))(CarouselBlockSlide);
